/**
 * API 환경을 결정하는 유틸리티
 * 우선순위:
 * 1. SSR에서 전달받은 환경변수 (window.__API_ENV__) - 서버 런타임 설정
 * 2. hostname 기반 추론
 * 3. 빌드 환경변수 (최후 fallback)
 */
export const getApiEnv = () => {
    // 1. SSR에서 전달받은 환경변수 (서버 우선)
    if (typeof window !== 'undefined' && window.__API_ENV__) {
        return window.__API_ENV__;
    }

    // 2. hostname 기반 환경 추론
    if (typeof window !== 'undefined' && window.location?.hostname) {
        const hostname = window.location.hostname;

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'development';
        }

        if (hostname === 'staging.fruitsfamily.com') {
            return 'staging';
        }

        if (
            hostname === 'fruitsfamily.com' ||
            hostname === 'www.fruitsfamily.com' ||
            hostname === 'production.fruitsfamily.com'
        ) {
            return 'production';
        }
    }

    // 3. 환경변수에서 읽기 (process.env / Vite)
    if (typeof process !== 'undefined' && process.env) {
        if (process.env.API_ENV) return process.env.API_ENV;
        if (process.env.VITE_API_ENV) return process.env.VITE_API_ENV;
    }
    
    // 4. 기본값
    return 'production';
};

export default getApiEnv;
